/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Grid } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { IconButton, Select, TextField } from '@michelin/acid-components';

interface SelectItem {
  label: string,
  value: string
}

interface Props {
  name: string,
  selectLabel: string,
  emptyLabel: string,
  textLabel: string,
  data: SelectItem[];
  list: string[]
  readOnly?: boolean,
  onChange: any;
}

function MultiSelectTool({
  name, selectLabel, emptyLabel, textLabel, data, list, readOnly, onChange,
}: Props) {
  const otherLabel = 'other';
  const checkErrors = new Map();

  list.forEach((item, index) => {
    const cloneList = [...list];
    cloneList.splice(index, 1);
    checkErrors.set(index, cloneList.includes(item) || item === `${otherLabel}:` || item === `${otherLabel}`);
  });

  const filterData = (value: string) => data.filter((item) => value === item.value || !list.includes(item.value) || item.value === 'other');
  const changeRow = (last: boolean, index: number, value?: string) => {
    const cloneList = [...list];
    if (last) cloneList.push('');

    if (value) {
      cloneList[index] = value;
    } else {
      cloneList.splice(index, 1);
    }

    onChange(cloneList, true);
  };

  if (list.length === 0 || list[list.length - 1]) list.push('');

  return (
    <>
      {readOnly && list.length <= 1 && (
        <div style={{
          width: '100%',
          textAlign: 'center',
          paddingTop: 14,
          paddingBottom: 14,
          opacity: 0.5,
        }}
        >
          {emptyLabel}
        </div>
      )}
      {list.map((item, index) => {
        const isLast = list.length === index + 1;
        const isItemOther = item.includes(otherLabel);
        const values = item.split(':');
        const buttonColumns = readOnly ? 0 : 1;
        if (readOnly && isLast) return null;
        return (
          <Grid key={`grid_${name}_${index}`} container spacing={2}>
            <Grid item xs={((isItemOther ? 6 : 12) - buttonColumns) as any}>
              <Select
                name={`multiSelectToolText_${name}_${index}`}
                label={selectLabel}
                value={values[0]}
                variant="standard"
                fullWidth
                options={filterData(item)}
                readOnly={readOnly}
                onChange={(e) => {
                  const value = typeof e.target.value === 'string' ? e.target.value : '';
                  changeRow(isLast, index, value);
                }}
              />
            </Grid>
            {isItemOther && (
              <Grid item xs={6}>
                <TextField
                  name={`multiSelectToolText_${name}_${index}`}
                  label={textLabel}
                  value={values[1]}
                  readOnly={readOnly}
                  error={!!checkErrors.get(index)}
                  onChange={(e) => {
                    const value = typeof e.target.value === 'string' ? e.target.value : '';
                    changeRow(false, index, `${otherLabel}:${value}`);
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            )}
            {!readOnly && (
              <Grid item xs={1}>
                {!isLast && (
                  <IconButton
                    name={`multiSelectToolButton_${name}_${index}`}
                    color="none"
                    variant="default"
                    size="small"
                    style={{ marginTop: 16, marginLeft: -8 }}
                    square
                    disabled={readOnly}
                    onClick={() => changeRow(isLast, index)}
                    fontSize="small"
                  >
                    <Delete />
                  </IconButton>
                )}
              </Grid>
            )}
          </Grid>
        );
      })}
    </>
  );
}

export default MultiSelectTool;
